export const getAuth = state => {
    return state
};